import { Link as RouterLink } from 'react-router-dom'
import {
  Button,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Skeleton,
  Switch,
  Text,
} from '@chakra-ui/react'

import { useIsAdmin, useTeam } from '@/react-query/team'
import {
  useUpdateUserSettings,
  useUserSettings,
} from '@/react-query/user-settings'
import Card from '@/views/components/Card'

export const VideoRecordingSettings = () => {
  const { data: userSettings, isLoading } = useUserSettings()
  const team = useTeam()
  const isTeamAdmin = useIsAdmin()
  const updateUserSettings = useUpdateUserSettings()

  return (
    <Card w={'100%'} p={6} px={10}>
      <Heading size={'md'}>Video Recording</Heading>
      {team.data ? (
        <HStack mt={6} w={'100%'} wrap={'wrap'}>
          <Text>Managed by your Team</Text>
          {isTeamAdmin && (
            <>
              &mdash;
              <Button
                as={RouterLink}
                variant={'brand-solid-white'}
                to={'/team'}
              >
                Go to Team Settings
              </Button>
            </>
          )}
        </HStack>
      ) : (
        <FormControl mt={6} display={'flex'} alignItems={'center'}>
          <Skeleton
            rounded={'1.25rem'}
            isLoaded={!isLoading}
            startColor="#f5f5f5"
            endColor="#d7d7d7"
          >
            <Switch
              id="enable-video-recording"
              onChange={(event) => {
                event.preventDefault()
                const value = event.target.checked
                updateUserSettings.mutate({
                  enableVideoRecording: value,
                })
              }}
              isChecked={userSettings?.enableVideoRecording || false}
              size={'lg'}
              variant={'brand-black'}
            />
          </Skeleton>
          <FormLabel htmlFor="enable-video-recording" mb="0" ml={'4'}>
            Enable video replays for new interviews
          </FormLabel>
        </FormControl>
      )}
    </Card>
  )
}
